import axios from 'axios';
import { useAlerts } from '../components/molecules/Alerts';
import { getAlertError, getAlertSuccess, getMafiaErrors } from '../utils';
export const useErrorHandler = () => {
    const { setAlerts } = useAlerts();
    const errorHandler = (err) => {
        if (axios.isAxiosError(err)) {
            setAlerts(getMafiaErrors(err));
        }
    };
    const setError = (message) => setAlerts(getAlertError(message));
    const setSuccess = (message) => setAlerts(getAlertSuccess(message));
    return {
        errorHandler,
        setError,
        setSuccess,
    };
};
